<template>
<div class="jumbotron">
    <h2 >Activate your account</h2>
    <b-alert v-if="errorMsg" variant="danger" show>{{errorMsg}}</b-alert>
    <b-alert v-if="successMsg" variant="success" show>{{successMsg}}</b-alert>

    <form @submit.prevent="activate" v-if="!finished">
        <div class="form-group">
            <label htmlFor="password">
                New Password
            </label>
            <b-form-input type="password" v-model="password" name="password" class="form-control" :state="pwdState"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              Password criteria not met
            </b-form-invalid-feedback>
        </div>
        <div class="form-group">
            <button class="btn btn-primary">
                Set password
            </button>
        </div>
    </form>
    <b-button class="btn btn-primary" to="/login" v-if="finished">
        Login
    </b-button>
</div>
</template>

<script>
export default {
    data () {
        return {
            key: '',
            password: '',
            errorMsg: '',
            successMsg: '',
            finished: false
        }
    },
    created: function () {      
      if( !this.$route.query.key ) {
        this.errorMsg = "Activation not possible: no key present"
        this.finished = true;
      } else {
        this.key = this.$route.query.key
      }
    },
    computed: {
      authenticated () {
        return this.$store.state.authenticated;
      },
      pwdState() {
        return this.password.length > 3 ? true : false
      }
    },
    methods: {
      activate () {
        this.$http.post(process.env.VUE_APP_API_URL + '/account/reset-password/finish', {
          "key": this.key,
          "newPassword": this.password
        }).then(response => {
          this.successMsg = "Account has been activated";
          this.finished = true;

        }, error => {
          this.finished = false;
          this.errorMsg = error.body.detail;
        })
      }
    }
};
</script>

<style scoped>
</style>
